/* Riwaaj Ka Rang — scroll reveal + light parallax for the editorial sections */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observed = new WeakSet();

  const reveal = (root = document) => {
    const targets = root.querySelectorAll('.rk-reveal:not(.rk-in)');
    if (!targets.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('rk-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('rk-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    targets.forEach((el) => {
      if (observed.has(el)) return;
      observed.add(el);
      io.observe(el);
    });
  };

  /* Layered parallax: every [data-rk-speed] element drifts at its own rate, so
     the photo/text plate moves slowly while the cards on top move faster. */
  const parallax = () => {
    if (reduced.matches || window.innerWidth < 990) return;

    const layers = [
      ...document.querySelectorAll('.rk-parallax-inner, [data-rk-speed]'),
    ].map((el) => ({
      el,
      speed: parseFloat(el.dataset.rkSpeed || '-34'),
      /* the element whose position drives the effect */
      anchor: el.classList.contains('rk-parallax-inner') ? el.parentElement : el,
    }));
    if (!layers.length) return;

    let ticking = false;

    const frame = () => {
      ticking = false;
      const vh = window.innerHeight;
      layers.forEach(({ el, speed, anchor }) => {
        const rect = anchor.getBoundingClientRect();
        if (rect.bottom < -300 || rect.top > vh + 300) return;
        const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = `translate3d(0, ${(progress * speed).toFixed(2)}px, 0)`;
      });
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    };

    /* The theme scrolls an inner wrapper, not the window, so listen in the
       capture phase to catch scroll events from whichever element moves. */
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  };

  const init = () => {
    reveal();
    parallax();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', (event) => reveal(event.target));
})();
